console.log("why product section loaded")

document.addEventListener('DOMContentLoaded', function() {
  const why_triggers = document.querySelectorAll('[why-product-trigger]');
  const why_product_wrapper = document.querySelector('[why-product-wrapper]');
  const why_product_container = document.querySelector('[why-product-container]');
  const why_product_close = document.querySelector('[why-product-close]');

  why_triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const product_handle = e.target.getAttribute('data-handle')
        const section_name = "gb-why-product-card"
        if (product_handle) {
            fetch(window.Shopify.routes.root + `products/${product_handle}?sections=${section_name}`)
            .then(response => response.json())
            .then(data => {
                const html = data[`${section_name}`];
                why_product_container.innerHTML = html;
                why_product_wrapper.classList.add("active");
                why_product_container.classList.add("active");
                document.body.style.overflow = 'hidden';
            });
        }
    })
  })

    why_product_close.addEventListener('click', (e) => {
        e.preventDefault();
        why_product_wrapper.classList.remove("active");
        why_product_container.classList.remove("active");
        document.body.style.overflow = 'visible';
    })
})